import { defineStore } from 'pinia'
import axiosInstance from '@/api/axios'

export const useApprovalStore = defineStore('approval', {
  state: () => ({
    // 내 대기 결재
    myPending: [],
    myPendingLoading: false,

    // 내가 요청한 결재
    myRequested: [],
    myRequestedLoading: false,

    // 내가 완료한 결재
    myCompleted: [],
    myCompletedLoading: false,

    // 참조 문서
    myReferences: [],
    myReferencesLoading: false,

    // 상세
    detail: null,
    detailLoading: false,
  }),

  actions: {
    async fetchMyPending() {
      this.myPendingLoading = true
      try {
        const response = await axiosInstance.get('approvals/my-pending/')
        this.myPending = response.data
      } catch (error) {
        console.error('Failed to fetch pending approvals:', error)
        throw error
      } finally {
        this.myPendingLoading = false
      }
    },

    async fetchMyRequested() {
      this.myRequestedLoading = true
      try {
        const response = await axiosInstance.get('approvals/my-requested/')
        this.myRequested = response.data
      } catch (error) {
        console.error('Failed to fetch requested approvals:', error)
        throw error
      } finally {
        this.myRequestedLoading = false
      }
    },

    async fetchMyCompleted() {
      this.myCompletedLoading = true
      try {
        const response = await axiosInstance.get('approvals/my-completed/')
        this.myCompleted = response.data
      } catch (error) {
        console.error('Failed to fetch completed approvals:', error)
        throw error
      } finally {
        this.myCompletedLoading = false
      }
    },

    async fetchDetail(id) {
      this.detailLoading = true
      try {
        const response = await axiosInstance.get(`approvals/${id}/`)
        this.detail = response.data
        return response.data
      } catch (error) {
        console.error('Failed to fetch approval detail:', error)
        throw error
      } finally {
        this.detailLoading = false
      }
    },

    async submitApproval(data) {
      const response = await axiosInstance.post('approvals/submit/', data)
      return response.data
    },

    async approve(id, comments = '') {
      const response = await axiosInstance.post(`approvals/${id}/approve/`, {
        is_approved: true,
        comments,
      })
      return response.data
    },

    async reject(id, comments = '') {
      const response = await axiosInstance.post(`approvals/${id}/reject/`, {
        is_approved: false,
        comments,
      })
      return response.data
    },

    async cancel(id) {
      const response = await axiosInstance.post(`approvals/${id}/cancel/`)
      return response.data
    },

    async fetchMyReferences() {
      this.myReferencesLoading = true
      try {
        const response = await axiosInstance.get('approvals/my-references/')
        this.myReferences = response.data
      } catch (error) {
        console.error('Failed to fetch reference approvals:', error)
        throw error
      } finally {
        this.myReferencesLoading = false
      }
    },

    async fetchSuggestedApprovers(documentType) {
      const response = await axiosInstance.get('approvals/suggested-approvers/', {
        params: { document_type: documentType }
      })
      return response.data
    },
  },
})
